module.exports = __webpack_public_path__ + "img/streaming_rabbit.2950a29f.svg";